import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { UserReviews } from '../../Reviews/UserReviews.js';
import { ProductDetailReviews } from './ProductDetailReviews.js';
import { useProductData } from '../../../context/product-context-hooks.js';

const ProductDetailReviewsDrawerContainer = ()=>{
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    const { product: { analyticsData: { ratingsSummary  } ,  } ,  } = useProductData();
    // default review count to zero when we don't have any ratings available
    const { reviewCount =0  } = ratingsSummary !== null && ratingsSummary !== void 0 ? ratingsSummary : {};
    if (!isPdpDrawerLayoutEnabled || reviewCount === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailReviews, null, /*#__PURE__*/ React.createElement(UserReviews, {
        isSingleColumn: true
    }));
};

export { ProductDetailReviewsDrawerContainer };
//# sourceMappingURL=ProductDetailReviewsDrawerContainer.js.map
